"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextField = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("@emotion/react");

var react_2 = require("react");

var textfield_1 = require("@react-aria/textfield");

var react_hook_form_1 = require("react-hook-form");

var components_utils_1 = require("@conte-ltd/components-utils");

var form_control_1 = require("./form-control");

function _TextField(props, fwRef) {
  var _a = (0, form_control_1.useFormControl)(),
      _b = _a.fieldProps,
      fieldProps = _b === void 0 ? {} : _b,
      setFieldsState = _a.setFieldsState,
      inheritIsRequired = _a.isRequired,
      inheritIsReadOnly = _a.isReadOnly,
      inheritIsDisabled = _a.isDisabled;

  var _c = props.as,
      as = _c === void 0 ? 'input' : _c,
      _d = props.isRequired,
      isRequired = _d === void 0 ? inheritIsRequired : _d,
      _e = props.isReadOnly,
      isReadOnly = _e === void 0 ? inheritIsReadOnly : _e,
      _f = props.isDisabled,
      isDisabled = _f === void 0 ? inheritIsDisabled : _f;
  var control = (0, react_hook_form_1.useFormContext)().control;

  var _g = (0, react_hook_form_1.useController)(__assign(__assign({
    control: control
  }, props), {
    rules: __assign(__assign({}, props.rules), {
      required: isRequired
    })
  })),
      _h = _g.field,
      controlRef = _h.ref,
      name = _h.name,
      value = _h.value,
      controlProps = __rest(_h, ["ref", "name", "value"]),
      fieldState = _g.fieldState;

  var newProps = (0, components_utils_1.mergeProps)(props, fieldProps, controlProps, {
    inputElementType: as,
    name: name,
    value: value,
    isRequired: isRequired,
    isReadOnly: isReadOnly,
    isDisabled: isDisabled
  });
  var ref = (0, react_2.useRef)(null);
  var inputProps = (0, textfield_1.useTextField)(newProps, ref).inputProps;
  (0, components_utils_1.useDeepCompareEffect)(function () {
    setFieldsState === null || setFieldsState === void 0 ? void 0 : setFieldsState(function (prev) {
      var _a;

      return __assign(__assign({}, prev), (_a = {}, _a[name] = __assign({
        value: value,
        isEmpty: (0, components_utils_1.isEmpty)(value, 1),
        isRequired: isRequired || false,
        isReadOnly: isReadOnly || false,
        isDisabled: isDisabled || false
      }, fieldState), _a));
    });
  }, [value, isRequired, isReadOnly, isDisabled, fieldState]);
  return as === 'input' ? (0, jsx_runtime_1.jsx)("input", __assign({
    css: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        padding: 0 0.4em;\n      "], ["\n        padding: 0 0.4em;\n      "]))),
    "data-required": isRequired || undefined,
    "data-readonly": isReadOnly || undefined,
    "data-disabled": isDisabled || undefined,
    "data-invalid": fieldState.invalid || undefined,
    required: props.required,
    ref: (0, components_utils_1.mergeRefs)([ref, fwRef, controlRef])
  }, (0, components_utils_1.mergeProps)(inputProps, (0, components_utils_1.styleProps)(props))), void 0) : (0, jsx_runtime_1.jsx)("textarea", __assign({
    "data-required": isRequired || undefined,
    "data-readonly": isReadOnly || undefined,
    "data-disabled": isDisabled || undefined,
    "data-invalid": fieldState.invalid || undefined,
    required: props.required,
    ref: (0, components_utils_1.mergeRefs)([ref, fwRef, controlRef])
  }, (0, components_utils_1.mergeProps)(inputProps, (0, components_utils_1.styleProps)(props))), void 0);
}

exports.TextField = (0, react_2.forwardRef)(_TextField);
var templateObject_1;